export default {
  modelName: 'license_type',
  label: '證照類型',
  fields: {
    area: {
      type: 'belongsTo',
      label: '地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    show_fields: {
      type: 'multi-select',
      label: '顯示欄位',
      rules: 'required',
      multiple: true,
      items: [
        {
          value: 'system_subclasses',
          text: '證照領域(用於其他類型)',
        },
        {
          value: 'using_status',
          text: '0：已停用， 1：使用中',
        },
        {
          value: 'license_status_number',
          text: '0：辦理中， 1：已核准',
        },
        {
          value: 'license_owner',
          text: '證照持有人(單選人員)',
        },
        {
          value: 'license_owned_factory',
          text: '證照持有人(顯示工廠名稱，不可編輯)',
        },
        {
          value: 'taker',
          text: '證照持有人(選擇顯示工廠名稱或單選人員)',
        },
        {
          value: 'setup_license',
          text: '報准人員證照',
        },
        {
          value: 'license_number',
          text: '證號',
        },
        {
          value: 'agent',
          text: '代理人',
        },
        {
          value: 'approval_letter',
          text: '核准函號',
        },
        {
          value: 'training_hours',
          text: '已受訓時數',
        },
        {
          value: 'valid_start_date',
          text: '有效起日',
        },
        {
          value: 'valid_end_date',
          text: '有效迄日',
        },
        {
          value: 'reminder',
          text: '證照管理人',
        },
        {
          value: 'remark',
          text: '備註',
        },
        {
          value: 'image',
          text: '證照圖片',
        },
        {
          value: 'attaches',
          text: '附件',
        },
        {
          value: 'processing_at',
          text: '辦理日期',
        },
        {
          value: 'retraining_at',
          text: '回訓起算日',
        },
        {
          value: 'retraining_rule',
          text: '回訓規則(幾年幾小時)',
        },
        {
          value: 'retraining_remind_date',
          text: '回訓提醒日',
        },
        {
          value: 'remind_date',
          text: '續辦提醒',
        },
        {
          value: 'permanent_validity',
          text: '永久效期',
        },
      ],
    },
    icon: {
      type: 'image',
      label: 'Icon',
      uploadUrl: '/license_type/icon/',
      maxWidth: '100px',
    },
    locales: {
      type: 'locales',
      // label: "多語言內容",
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 100,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
